/**
 * @file download-file-round.icon.tsx
 * @description Компонент для отображения иконки части компонента @components/ui/data/dictionary.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const DownloadFileRoundIcon = ({ className, color = '#045A9A', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick}>
            <svg
                width="1.482vmin"
                height="1.5878vmin"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.99967 0.499756C10.8498 0.499756 13.9998 3.64983 13.9998 7.49992C13.9998 11.35 10.8498 14.5001 6.99967 14.5001C3.14958 14.5001 -0.000488281 11.35 -0.000488281 7.49992C-0.000488281 3.64983 3.14958 0.499756 6.99967 0.499756ZM4.19961 11H9.79974V9.59997H4.19961V11ZM9.79974 6.09989H8.0497V3.29982H5.94965V6.09989H4.19961L6.99967 8.89995L9.79974 6.09989Z"
                    fill={color}
                />
            </svg>
        </div>
    );
};
